/**
 * Downloads a Blob as a file
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Gets file extension based on export format
 */
export const getFileExtension = (format: 'excel' | 'pdf' | 'json'): string => {
  switch (format) {
    case 'excel':
      return 'xlsx';
    case 'pdf':
      return 'pdf';
    case 'json':
      return 'json';
  }
};

/**
 * Generates a filename for report export
 */
export const generateReportFilename = (
  reportType: string,
  format: 'excel' | 'pdf' | 'json',
  suffix?: string
): string => {
  const date = new Date().toISOString().split('T')[0];
  const extension = getFileExtension(format);
  const parts = [reportType, date];
  if (suffix) parts.push(suffix);
  return `${parts.join('-')}.${extension}`;
};
